export default "__VITE_ASSET__CZW7ldx3__"